import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { TextField, Button, Container, Typography, Box, CircularProgress, Alert } from '@mui/material';
import api from '../api/axios';

const QualificationSchema = Yup.object().shape({
  title: Yup.string().required('Required'),
});

const AddEditQualificationPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({ title: '' });
  const [loading, setLoading] = useState(!!id);
  const [error, setError] = useState('');

  useEffect(() => {
    if (id) {
      api.get(`/qualifications/${id}`)
        .then(res => setInitialValues({ title: res.data.title }))
        .catch(() => setError('Failed to load qualification'))
        .finally(() => setLoading(false));
    }
  }, [id]);

  if (loading) return <CircularProgress />;

  return (
    <Container maxWidth="sm">
      <Box mt={4}>
        <Typography variant="h5">{id ? 'Edit' : 'Add'} Qualification</Typography>
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validationSchema={QualificationSchema}
          onSubmit={async (values, { setSubmitting }) => {
            setError('');
            try {
              if (id) {
                await api.put(`/qualifications/${id}`, values);
              } else {
                await api.post('/qualifications', values);
              }
              navigate('/');
            } catch (e) {
              setError('Save failed');
            }
            setSubmitting(false);
          }}
        >
          {({ isSubmitting, errors, touched }) => (
            <Form>
              <Field
                as={TextField}
                name="title"
                label="Title"
                fullWidth
                margin="normal"
                error={touched.title && !!errors.title}
                helperText={touched.title && errors.title}
              />
              {error && <Alert severity="error">{error}</Alert>}
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                disabled={isSubmitting}
                sx={{ mt: 2 }}
              >
                {id ? 'Update' : 'Add'}
              </Button>
            </Form>
          )}
        </Formik>
      </Box>
    </Container>
  );
};

export default AddEditQualificationPage; 